import { ref } from "vue";
import { f as defaultsKey } from "../../../keys-DUCx0SNv.mjs";
const bootstrapPlugin = {
  install(app, options) {
    const val = (options == null ? void 0 : options.components) ?? {};
    app.provide(defaultsKey, ref(val));
  }
};
export {
  bootstrapPlugin
};
//# sourceMappingURL=index.mjs.map
